import {
    Card
} from "@mui/material";
import { startCase } from "lodash";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ExpandableReactQuill from "../Input/ExpandableReactQuill";

// const Card = styled.div`
//     border-radius: 0.5rem;
//     border-width: 0.1px;
//     border-color: rgba(200, 226, 226, 0.94);
//     border-style: solid;
//     background-color: var(--color-white);
//     box-shadow: 12px 12px 20px rgba(101, 151, 132, 0.16);
//     display: flex;
//     overflow: hidden;
//     padding: 1rem;'
//     flex-direction: column;
//     `;
//     // ${(p) => p.theme.breakpoints.down("sm")} {
//     //     flex-direction: column;
//     //   }

//     Card.Content = styled.div`
//     display: flex;
//     flex-direction: column;
//     padding: 1rem;
//     gap: 1rem;
//     flex-grow: 1;
// `;

// function Testimonial({ name, image, title, testimoni, idTestimoni, className }) {
//     return (
//         <Card className={className}>
//             <div className='d-flex'>
//                 <Avatar
//                     src={image}
//                     sx={{ width: 150, height: 200 }}
//                     variant='square'
//                 />
//             </div>
//             <div className='d-flex flex-column p-1'>
//                 <div>
//                     <ExpandableReactQuill
//                         dataId={idTestimoni}
//                         text={testimoni}
//                         minTextLength={150}
//                     />
//                 </div>
//                 <div className='d-flex flex-column mt-3'>
//                     <b style={{ fontSize: "15px" }}>{name}</b>
//                     <b style={{ fontSize: "13px" }} className='text-primary-main'>{title}</b>
//                 </div>
//             </div>
//         </Card>
//     )
// }

function Testimonial({
    name,
    image,
    title,
    testimoni,
    idTestimoni,
    className,
}) {
    const capitalized = (value) => startCase(value.toLowerCase());
    // const suspensify = useCallback((component) => {
    //     const defaultFallback = <Loading />;
    //     return <Suspense fallback={defaultFallback}> {component} </Suspense>;
    // }, []);

    return (
        <Card
            className={`${className} d-flex gap-1 p-2`}
            sx={{
                height: "100%",
                borderRadius: "15px",
                boxShadow: "10px 10px rgba(0, 0, 0)",
            }}>
            {/* {suspensify(
                // <Avatar
                //     className="testimoni-avatar"
                //     src={image}
                //     variant="rounded"
                //     sx={{
                //         width: "150px",
                //         height: "200px",
                //     }}
                // /> */}
            <LazyLoadImage
                className="testimoni-avatar"
                src={image}
                style={{
                    width: "150px",
                    height: "200px",
                }}
            />
            <div className="content-testimoni d-flex flex-column justify-content-between">
                <div className="mb-2">
                    <ExpandableReactQuill
                        dataId={idTestimoni}
                        text={testimoni}
                        minTextLength={300}
                    />
                </div>
                <div>
                    <h5 className="testimoni-name text-white">
                        {capitalized(name)}
                    </h5>
                    <p className="testimoni-title text-white">{title}</p>
                </div>
            </div>
        </Card>
    );
}

export default Testimonial;
